var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#4A5568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .afiado_een{fill:#4A5568;} "), /*#__PURE__*/React.createElement("path", {
    className: "afiado_een",
    d: "M16,4.686L4.686,16L16,27.314L27.314,16L16,4.686z M10.343,16L16,10.343L21.657,16L16,21.657L10.343,16z "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.36e9b668c2e4307cd957b6117dcb6c3c.svg";
export { ForwardRef as ReactComponent };